import Cookie from 'common/services/util/-RFC.Cookie';


angular.module('directives').directive('tooltipScroll', () => ({
    template: '',
    restrict: 'A',
    replace: false,
    link: (scope, element) => {

        // show tooltip
        element.parent().on('mouseenter', () => {

            if (!Cookie.get('scrolltooltip')) {

                element.addClass('flipInX');
                setTimeout(() => {

                    element.removeClass('flipInX');

                }, CWCONFIG.timeouts.tooltip);

            }

            Cookie.set('scrolltooltip', true, { expires: 365, path: '/' });

        });

    },
}));



// WEBPACK FOOTER //
// ./scripts/directives/tooltip-scroll.js